module.exports = __webpack_public_path__ + "img/illustration-landing-stockeur.61dd6283.png";